// EditSectionFeatures — Section 4 of editRealty.
// Substrate: design/editRealty.html lines 626-671 — `<section id="sec-features">`.
//
// Backend-truth:
//   * Feature catalog → GET /api/realty/features/ (FeatureSerializer = {id, name}).
//   * Per-property toggles via POST /properties/{id}/features/ {feature_id}
//     and DELETE /properties/{id}/features/{feature_id}/.
//
// The HTML chips use English `value` attrs ("elevator", "ac", ...) with
// per-chip icons. These string keys are NOT backend Feature.name values
// (Feature.name is whatever has been seeded in the catalog — Ukrainian or
// otherwise). Per R6.1 STEP R6.1.4 ("DO NOT invent payloads, invent update
// semantics, infer backend contracts"), we render the chip grid from the
// real Feature catalog instead of the design's hardcoded list.
//
// RIC-3.0 — Feature.icon (backend) drives the per-chip icon. Rows whose
// icon has not been set in admin fall back to the generic tag icon.

const GENERIC_FEATURE_ICON = "fa-solid fa-tag";

function EditSectionFeatures({
  catalog,
  catalogState,
  catalogError,
  selectedIds,
  onToggle,
}) {
  return (
    <section
      id="sec-features"
      className="ap-pane"
      aria-labelledby="ap-pane-features"
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-features">
          <i className="fa-solid fa-tags" aria-hidden="true" />
          Особливості
        </h2>
        <p>Виберіть всі особливості, що відповідають об'єкту.</p>
      </header>

      {catalogState === "loading" ? (
        <p className="form-hint">Завантаження каталогу особливостей…</p>
      ) : catalogState === "error" ? (
        <p className="form-hint text-danger" role="alert">
          {catalogError || "Не вдалося завантажити особливості."}
        </p>
      ) : catalog.length === 0 ? (
        <p className="form-hint">Каталог особливостей порожній.</p>
      ) : (
        <div className="features-grid">
          {catalog.map((feature) => {
            const checked = selectedIds.has(feature.id);
            return (
              <label key={feature.id} className="feature-chip-input">
                <input
                  type="checkbox"
                  name="features"
                  value={feature.id}
                  checked={checked}
                  onChange={() => onToggle(feature.id)}
                />
                <i
                  className={feature.icon || GENERIC_FEATURE_ICON}
                  aria-hidden="true"
                />
                {feature.name}
              </label>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default EditSectionFeatures;
